export const LANGS = { EN: "en", FR: "fr", ES: "es" };

export const STR = {
  en: {
    appTitle: "Simulator 360°",
    appName: "Simulator 360°",
    metaTitle: "Simulator 360° — Educational Portfolio Tool",
    metaDesc: "Model and understand your portfolio with DCA, Crypto, AI Trading, and Web3. Illustrative results. Not financial advice.",
    ogImage: "/assets/branding/og-en.png",
    appSubtitle: "Educational tool to learn how to model a digital portfolio.",
    config: "Portfolio Configuration",
    capital: "Initial Digital Capital (USD)",
    monthlyContributionLabel: "Monthly Contribution (USD)",
    monthlyContributionHelp: "Amount added each month and distributed according to your current allocation percentages.",
    profile: "Member Profile",
    conservative: "Conservative",
    balanced: "Balanced",
    exotic: "Exotic",
    customProfile: "(Custom)",
    customProfileMessage: "Allocations have been manually modified",
    autoNormalize: "Auto-normalize",
    custom: "Custom",
    customHint: "(Custom profile)",
    resetPreset: "Reset to profile",
    saveAsDefault: "Save as new default",
    login: "Login",
    logout: "Logout",
    changeLanguage: "Change language",
    guide: "Guide",
    backoffice: "Backoffice",

    baskets: "Baskets",
    dcaCrypto: "DCA Bitcoin & Crypto",
    btcDca: "DCA Bitcoin & Crypto",
    crypto: "DCA Bitcoin & Crypto",
    aiTrading: "AI Trading",
    web3: "Web3 Staking & Farming",

    aiSplit: "AI Trading Split",
    sigmai: "Sigmai",
    sugair: "Sugair",
    jairvis: "Jairvis",
    jarvis: "Jairvis",

    assumptions: "Return Assumptions (editable)",
    annual: "Annual",
    monthly: "Monthly",
    rateDcaCrypto: "DCA Bitcoin & Crypto: 40% annual",
    rateBtc: "DCA Bitcoin & Crypto: 40% annual",
    rateCrypto: "DCA Bitcoin & Crypto: 40% annual",
    rateJairvis: "Jairvis: 3.48% monthly",
    rateJarvis: "Jairvis: 3.48% monthly",
    rateSugair: "Sugair: 4.50% monthly",
    rateSigmai: "Sigmai: 3.48% monthly",
    rateWeb3: "Web3: 3.50% monthly",

    projections: "Projections",
    horizon90d: "90 days",
    horizon1y: "1 year",
    horizon3y: "3 years",
    horizon5y: "5 years",

    results: "Results",
    basket: "Basket",
    allocationUsd: "Allocation (USD)",
    rate: "Rate",
    fv90d: "FV 90d",
    fv1y: "FV 1 year",
    fv5y: "FV 5 years",
    delta: "Δ vs initial",
    total: "TOTAL",

    actions: "Actions",
    copyLink: "Copy link",
    exportPdf: "Export PDF",

    tooltipBtc: "Progressive accumulation via DCA on Bitcoin and Crypto.",
    tooltipCrypto: "Progressive accumulation via DCA on Bitcoin and Crypto.",
    tooltipDcaCrypto: "Progressive accumulation via DCA on Bitcoin and Crypto.",
    tooltipAI: "AI bots: Sigmai, Sugair, Jairvis (internal split).",
    tooltipWeb3: "Yields via staking/farming (KAP3, etc.).",

    disclaimer:
      "Educational Tool: The DCA Club is not an investment company or a recommendation service. Everything done in the Club has a solely educational objective within a technical framework, so that each member can be better prepared when navigating the digital world on their own. This tool aims to teach how a portfolio is created and adjusted, and the portfolio could also be built with other digital tools different from those proposed here, always for educational purposes. All results presented are illustrative and may not reflect reality. This is not financial advice. Past performance does not guarantee future returns. Each member will always be solely responsible for their own decisions.",
    eduBadge: "Educational Tool",

    langSwitch: "EN",
    
    // Additional translations
    portfolioAllocation: "Portfolio Allocation",
    portfolioGrowthProjection: "Portfolio Growth Projection",
    detailedProjections: "Detailed Projections",
    totalCapital: "Total Capital",
    finalValue: "Final Value",
    totalGain: "Total Gain",
    returnPercent: "Return %",
    aiTradingBreakdown: "AI Trading Breakdown",
    aiAllocationBreakdown: "AI Allocation Breakdown",
    allocationsMustSum: "Allocations must sum to 100%. Current total:",
    aiSplitMustSum: "AI split must sum to 100%. Current:",
    monthlyReturns: "monthly returns",
    ofAI: "of AI",
    totalPortfolio: "TOTAL PORTFOLIO",
    contributionsTotal: "Cumulative Contributions",
    netGain: "Net Gain",
    roi: "ROI",
    basketContrib: "Cumulative Contribution",
    
    // E) New text keys for UI improvements
    seeMore: "See more",
    seeLess: "See less",
    contributions: "Cumulative Contributions",
    compounding: "Compound Growth",
    
    // D) AI Trading Performance Fee tooltips
    aiPerformanceFeeTooltip: "Net return after 30% weekly performance fee on gains",
    grossRate: "Gross Rate",
    netRate: "Net Rate",
    
    // Jairvis specific tooltips
    aiJairvis: "Jairvis",
    tooltipJairvis: "Returns managed by Jairvis.",
    
    // Social image alt text
    socialImageAlt: "DCA Vision 360° - Educational tool for modeling digital portfolios",
    
    // B) Data Export
    exportCsv: "Export CSV",
    exportExcel: "Export Excel",
    exportPdf: "Export PDF",
    exportSuccess: "Export successful!",
    exportError: "Export error",
    
    // Export Confirmation Modal
    exportWarningTitle: "Educational Content Disclaimer",
    exportWarningMessage: "This document contains educational projections only. It is NOT financial advice. Past performance does not guarantee future results. You are solely responsible for your investment decisions.",
    exportWarningConfirm: "I understand, download document",
    exportWarningCancel: "Cancel",
    exportContact: "For more information, contact: team@thedcaclub.com",
    
    // Section descriptions
    configDescription: "Adjust your initial capital and monthly contributions to see how your portfolio could grow over time.",
    portfolioAllocationDescription: "Drag the sliders to distribute your investment across the 3 baskets: DCA Bitcoin & Crypto, AI Trading, and Web3. The total must equal 100%.",
    assumptionsDescription: "These rates are educational estimates based on historical data. Past performance does not guarantee future results. Feel free to adjust them to match your own assumptions.",
    assumptionsWarning: "Important: Act with responsibility and follow a well-defined DCA plan. These are projections, not promises.",
    aiTradingAnnualLabel: "AI Trading — Average Annual Rate",
    aiTradingAnnualHelp: "Aggregated annual return for the AI Trading basket (blended from Sigmai, Sugair & Jairvis). Editing this applies an equivalent monthly rate to all three bots.",
    // Capital Flow
    capitalFlowTitle: "Capital Flow — Where your money goes",
    capitalFlowSubtitle: "Visual breakdown of how your capital is distributed across baskets, AI bots, and projected over time.",
    flowColCapital: "CAPITAL",
    flowColBaskets: "BASKETS",
    flowColAiSplit: "AI SPLIT",
    flowColFinalValue: "FINAL VALUE",
    flowInitial: "Initial capital",
    flowHoverHint: "Hover a flow to see details",
    // Portfolio Card
    portfolioCardTitle: "Your Portfolio Card",
    portfolioCardSubtitle: "A collectible snapshot of your simulation — ready to download & share.",
    portfolioCardDescription: "Download it as a high-quality image or share directly on WhatsApp. The rarity depends on your member profile.",
    portfolioCardProfile: "Profile",
    portfolioCard5yProjection: "5-year projection",
    portfolioCardEducational: "Simulator 360°",
    portfolioCardDownloadPng: "Download PNG",
    portfolioCardDownloading: "Generating...",
    cardDownloadError: "Could not generate image. Please try again.",
    portfolioCardPreparing: "Preparing image...",
    portfolioCardAttachNotice: "Your card was downloaded. Attach the downloaded image in WhatsApp Web to send it with the message.",
    // Scenario Multiverse
    multiverseTitle: "Scenario Multiverse — Explore parallel futures",
    multiverseSubtitle: "Compare how your portfolio could evolve under 3 alternative return scenarios.",
    scenarioPessimistic: "Pessimistic",
    scenarioRealistic: "Realistic",
    scenarioOptimistic: "Optimistic",
    scenarioCurrent: "current",
    multiverseFV5y: "Final Value · 5Y",
    multiverseNetGain: "Net gain",
    multiverseDisclaimer: "Educational illustration only — returns are not guaranteed.",
    projectionDescription: "Visualize how your portfolio could grow with compound interest over different time periods.",
    
    // Help section
    howItWorksTitle: "How Does the Simulator Work?",
    howItWorksStep1: "1. Set your capital",
    howItWorksStep1Desc: "Enter your initial investment amount and monthly contribution.",
    howItWorksStep2: "2. Allocate your portfolio",
    howItWorksStep2Desc: "Use the sliders to distribute your capital across the 3 baskets: DCA Bitcoin & Crypto, AI Trading, and Web3.",
    howItWorksStep3: "3. Adjust return assumptions",
    howItWorksStep3Desc: "Modify the expected return rates if you have your own projections.",
    howItWorksStep4: "4. Analyze projections",
    howItWorksStep4Desc: "Review the growth charts and detailed tables to understand potential outcomes.",
    howItWorksDisclaimer: "Remember: This is an educational tool. Results are illustrative and do not constitute financial advice.",
    
    // Parcours Onboarding
    parcoursTitle: "Well done 👏 Your parcours starts here",
    parcoursSubtitle: "You've clarified your profile. Now, let's move forward step by step, no pressure.\nYou can stop and resume whenever you want.",
    parcoursProfileLabel: "Profile",
    parcoursAllocationLabel: "Allocation",
    parcoursTimelineWeb3: "Web3 — immediate momentum",
    parcoursTimelineAI: "AI Trading — rhythm & structure",
    parcoursTimelineDCA: "DCA — long-term stability",
    parcoursCTAStart: "Launch the parcours 🚀",
    parcoursCTAStartSubtext: "Step 1: Web3 (immediate momentum)",
    parcoursCTABack: "Back to Sim360",
    parcoursResume: "Resume where I left off",
    parcoursNoSnapshot: "Start by completing Simulator 360° to define your profile",
    goToParcours: "Continue to Parcours",
    goToParcoursDesc: "Ready to put your plan into action? Follow a step-by-step guided path.",
    parcoursMapTitle: "Your journey map",
    parcoursStartAlert: "Navigation to Step 1 (Web3) will be implemented soon",
    
    // Jairvis Maintenance
    enMaintenance: "under maintenance",
    jairvisMaintenanceShort: "Temporarily suspended",
    jairvisMaintenanceTitle: "❗ Key Issue Identified: trades open too long",
    jairvisMaintenanceText1: "We noticed that some trades on JAIRVIS remain open for too long periods.",
    jairvisMaintenanceText2: "In the Club's quality standards, it's important that AIs close trades several weekends per month so members can access their deposits if they need withdrawals or other needs.",
    jairvisMaintenanceText3: "Trades that are too long therefore delay:",
    jairvisMaintenancePoint1: "fund availability for members",
    jairvisMaintenanceText4: "Therefore, we have temporarily suspended access to JAIRVIS copy trading, while its creator reworks the AI to meet the required standards, with the goal of having 100% of trades closed 2 to 3 times per week.",
    
    // AI Trading Pole Vision
    aiPoleVisionTitle: "🎯 AI Trading Pole Vision",
    aiPoleVisionText1: "The AI Trading Pole's vision is to constantly monitor AI results and maintain direct communication with creators to uphold our quality standards.",
    aiPoleVisionText2: "It's not a bad thing if an AI returns to the 'garage' when it no longer meets standards. We are constantly analyzing and following different trading AIs to then offer them in the Club.",
    aiPoleVisionText3: "This is an adaptive and evolving approach. Quality for our members is most important.",
    aiPoleVisionText4: "One factor for an AI to be approved: it must have at least 500 trades made on the same account.",

    // Navigation
    backofficeExternal: "Backoffice",
    myPortafolio: "My Portafolio",

    // My Portafolio promo block (home)
    portafolioPromoTitle: "Track everything in My Portafolio",
    portafolioPromoLead: "Your unified member dashboard — connect your MT4/5 (Sigmai, Sugair, Jairvis), your BEP20 wallet, your KAP3 plans and your manual DCA, all in one neon view.",
    portafolioPromoFeature1: "MT4/5 trading metrics in real time via MetaApi",
    portafolioPromoFeature2: "BEP20 wallet + KAP3 buy plans on-chain",
    portafolioPromoFeature3: "Manual DCA Bitcoin tracker + Performance Card",
    portafolioPromoSignup: "Create your account",
    portafolioPromoLogin: "I already have an account",

    // Auth (email/password)
    authLoginTitle: "Welcome back",
    authRegisterTitle: "Create your account",
    authEmail: "Email",
    authPassword: "Password",
    authName: "Name (optional)",
    authSubmitLogin: "Sign in",
    authSubmitRegister: "Create account",
    authToRegister: "No account yet? Sign up",
    authToLogin: "Already have an account? Sign in",
    authForgot: "Forgot password?",
    authForgotHelp: "We do not send emails. Open a support ticket and we'll reset it for you.",
    authOr: "or",
    authGoogle: "Continue with Google",
    authError: "Sign-in failed",
    authPasswordHint: "Minimum 6 characters",
  },

  fr: {
    appTitle: "Simulateur 360°",
    appName: "Simulateur 360°",
    metaTitle: "Simulateur 360° — Outil Pédagogique de Portefeuille",
    metaDesc: "Modélisez et comprenez votre portefeuille avec DCA, Crypto, Trading IA et Web3. Résultats illustratifs. Pas de conseil financier.",
    ogImage: "/assets/branding/og-fr.png",
    appSubtitle: "Outil pédagogique pour apprendre à modéliser un portefeuille numérique.",
    config: "Configuration du portefeuille",
    capital: "Capital digital initial (USD)",
    monthlyContributionLabel: "Apport mensuel (USD)",
    monthlyContributionHelp: "Montant ajouté chaque mois et réparti selon vos pourcentages d'allocation actuels.",
    profile: "Profil de membre",
    conservative: "Conservateur",
    balanced: "Équilibré",
    exotic: "Exotique",
    customProfile: "(Personnalisé)",
    customProfileMessage: "Les allocations ont été modifiées manuellement",
    autoNormalize: "Auto-normaliser",
    custom: "Personnalisé",
    customHint: "(Profil personnalisé)",
    resetPreset: "Réinitialiser le profil",
    saveAsDefault: "Enregistrer comme valeurs par défaut",
    login: "Connexion",
    logout: "Déconnexion", 
    changeLanguage: "Changer de langue",
    guide: "Guide",
    backoffice: "Backoffice",

    baskets: "Paniers",
    dcaCrypto: "DCA Bitcoin & Crypto",
    btcDca: "DCA Bitcoin & Crypto",
    crypto: "DCA Bitcoin & Crypto",
    aiTrading: "Trading avec IA",
    web3: "Web3 Staking & Farming",

    aiSplit: "Répartition Trading IA",
    sigmai: "Sigmai",
    sugair: "Sugair",
    jairvis: "Jairvis",
    jarvis: "Jairvis",

    assumptions: "Hypothèses de rendement (éditables)",
    annual: "Annuel",
    monthly: "Mensuel",
    rateDcaCrypto: "DCA Bitcoin & Crypto : 40% par an",
    rateBtc: "DCA Bitcoin & Crypto : 40% par an",
    rateCrypto: "DCA Bitcoin & Crypto : 40% par an",
    rateJairvis: "Jairvis : 3,48% par mois",
    rateJarvis: "Jairvis : 3,48% par mois",
    rateSugair: "Sugair : 4,50% par mois",
    rateSigmai: "Sigmai : 3,48% par mois",
    rateWeb3: "Web3 : 3,50% par mois",

    projections: "Projections",
    horizon90d: "90 jours",
    horizon1y: "1 an",
    horizon3y: "3 ans",
    horizon5y: "5 ans",

    results: "Résultats",
    basket: "Panier",
    allocationUsd: "Allocation (USD)",
    rate: "Taux",
    fv90d: "VF 90j",
    fv1y: "VF 1 an",
    fv5y: "VF 5 ans",
    delta: "Δ vs initial",
    total: "TOTAL",

    actions: "Actions",
    copyLink: "Copier le lien",
    exportPdf: "Exporter en PDF",

    tooltipBtc: "Accumulation progressive via DCA sur Bitcoin et Crypto.",
    tooltipCrypto: "Accumulation progressive via DCA sur Bitcoin et Crypto.",
    tooltipDcaCrypto: "Accumulation progressive via DCA sur Bitcoin et Crypto.",
    tooltipAI: "Bots IA : Sigmai, Sugair, Jairvis (répartition interne).",
    tooltipWeb3: "Rendements via staking/farming (KAP3, etc.).",

    disclaimer:
      "Outil éducatif : Le DCA Club n'est pas une société d'investissement ni un service de recommandation. Tout ce qui est proposé dans le Club a un objectif purement éducatif et dans un cadre technique, afin que chaque membre puisse être mieux préparé lorsqu'il naviguera seul dans le monde numérique. Cet outil a pour but d'enseigner comment créer et ajuster un portefeuille, lequel pourrait également être construit avec d'autres outils numériques que ceux proposés ici, uniquement à des fins éducatives. Tous les résultats présentés sont illustratifs et peuvent ne pas refléter la réalité. Ce n'est pas un conseil financier. Les performances passées ne garantissent pas les performances futures. Chaque membre reste toujours seul responsable de ses décisions.",
    eduBadge: "Outil éducatif",

    langSwitch: "ES", // etiqueta del botón para cambiar
    
    // Additional translations
    portfolioAllocation: "Allocation du portefeuille",
    portfolioGrowthProjection: "Projection de croissance du portefeuille",
    detailedProjections: "Projections détaillées",
    totalCapital: "Capital total",
    finalValue: "Valeur finale",
    totalGain: "Gain total",
    returnPercent: "Rendement %",
    aiTradingBreakdown: "Répartition Trading IA",
    aiAllocationBreakdown: "Répartition de l'allocation IA",
    allocationsMustSum: "Les allocations doivent totaliser 100%. Total actuel:",
    aiSplitMustSum: "La répartition IA doit totaliser 100%. Actuel:",
    monthlyReturns: "rendements mensuels",
    ofAI: "de l'IA",
    totalPortfolio: "PORTEFEUILLE TOTAL",
    contributionsTotal: "Apports cumulés",
    netGain: "Gain net",
    roi: "ROI",
    basketContrib: "Apport cumulé",
    
    // E) New text keys for UI improvements
    seeMore: "Voir plus",
    seeLess: "Voir moins",
    contributions: "Apports cumulés",
    compounding: "Croissance composée",
    
    // D) AI Trading Performance Fee tooltips
    aiPerformanceFeeTooltip: "Rendement net après 30% de commission hebdomadaire sur les gains",
    grossRate: "Taux brut",
    netRate: "Taux net",
    
    // Jairvis specific tooltips
    aiJairvis: "Jairvis",
    tooltipJairvis: "Rendements gérés par Jairvis.",
    
    // Social image alt text
    socialImageAlt: "DCA Vision 360° - Outil éducatif pour modéliser des portefeuilles digitaux",
    
    // B) Data Export
    exportCsv: "Exporter CSV",
    exportExcel: "Exporter Excel",
    exportPdf: "Exporter PDF",
    exportSuccess: "Export réussi!",
    exportError: "Erreur lors de l'export",
    
    // Export Confirmation Modal
    exportWarningTitle: "Avertissement de Contenu Éducatif",
    exportWarningMessage: "Ce document contient des projections éducatives uniquement. Ce N'EST PAS un conseil financier. Les performances passées ne garantissent pas les résultats futurs. Vous êtes seul responsable de vos décisions d'investissement.",
    exportWarningConfirm: "Je comprends, télécharger le document",
    exportWarningCancel: "Annuler",
    exportContact: "Pour plus d'informations, contactez : team@thedcaclub.com",
    
    // Section descriptions
    configDescription: "Ajustez votre capital initial et vos contributions mensuelles pour voir comment votre portefeuille pourrait évoluer dans le temps.",
    portfolioAllocationDescription: "Faites glisser les curseurs pour répartir votre investissement entre les 3 paniers DCA Bitcoin & Crypto, Trading avec IA et Web3. Le total doit être égal à 100%.",
    assumptionsDescription: "Ces taux sont des estimations pédagogiques basées sur des données historiques. Les performances passées ne garantissent pas les résultats futurs. N'hésitez pas à les ajuster selon vos propres hypothèses.",
    assumptionsWarning: "Important : Agissez avec responsabilité et suivez un plan DCA bien défini. Ce sont des projections, pas des promesses.",
    aiTradingAnnualLabel: "Trading avec IA — Taux annuel moyen",
    aiTradingAnnualHelp: "Rendement annuel agrégé du panier Trading avec IA (moyenne pondérée Sigmai, Sugair & Jairvis). La modification applique un taux mensuel équivalent aux trois bots.",
    // Capital Flow
    capitalFlowTitle: "Flux de Capital — Où va ton argent",
    capitalFlowSubtitle: "Visualisation de la répartition de ton capital entre les paniers, les bots IA, et sa projection dans le temps.",
    flowColCapital: "CAPITAL",
    flowColBaskets: "PANIERS",
    flowColAiSplit: "RÉPARTITION IA",
    flowColFinalValue: "VALEUR FINALE",
    flowInitial: "Capital initial",
    flowHoverHint: "Survole un flux pour voir le détail",
    // Portfolio Card
    portfolioCardTitle: "Ta Carte Portefeuille",
    portfolioCardSubtitle: "Un instantané collectionnable de ta simulation — prêt à télécharger & partager.",
    portfolioCardDescription: "Télécharge-la en image haute qualité ou partage-la directement sur WhatsApp. La rareté dépend de ton profil de membre.",
    portfolioCardProfile: "Profil",
    portfolioCard5yProjection: "Projection 5 ans",
    portfolioCardEducational: "Simulateur 360°",
    portfolioCardDownloadPng: "Télécharger PNG",
    portfolioCardDownloading: "Génération...",
    cardDownloadError: "Impossible de générer l'image. Réessaie.",
    portfolioCardPreparing: "Préparation de l'image...",
    portfolioCardAttachNotice: "Ta carte a été téléchargée. Joins l'image téléchargée dans WhatsApp Web pour l'envoyer avec le message.",
    // Scenario Multiverse
    multiverseTitle: "Multivers de Scénarios — Explore des futurs parallèles",
    multiverseSubtitle: "Compare comment ton portefeuille pourrait évoluer selon 3 scénarios de rendement alternatifs.",
    scenarioPessimistic: "Pessimiste",
    scenarioRealistic: "Réaliste",
    scenarioOptimistic: "Optimiste",
    scenarioCurrent: "actuel",
    multiverseFV5y: "Valeur Finale · 5 ans",
    multiverseNetGain: "Gain net",
    multiverseDisclaimer: "Illustration pédagogique uniquement — les rendements ne sont pas garantis.",
    projectionDescription: "Visualisez comment votre portefeuille pourrait croître avec les intérêts composés sur différentes périodes.",
    
    // Help section
    howItWorksTitle: "Comment fonctionne le simulateur ?",
    howItWorksStep1: "1. Définissez votre capital",
    howItWorksStep1Desc: "Entrez le montant de votre investissement initial et votre contribution mensuelle.",
    howItWorksStep2: "2. Répartissez votre portefeuille",
    howItWorksStep2Desc: "Utilisez les curseurs pour distribuer votre capital entre les 3 paniers DCA Bitcoin & Crypto, Trading avec IA et Web3.",
    howItWorksStep3: "3. Ajustez les hypothèses de rendement",
    howItWorksStep3Desc: "Modifiez les taux de rendement attendus si vous avez vos propres projections.",
    howItWorksStep4: "4. Analysez les projections",
    howItWorksStep4Desc: "Consultez les graphiques de croissance et les tableaux détaillés pour comprendre les résultats potentiels.",
    howItWorksDisclaimer: "Rappel : Ceci est un outil pédagogique. Les résultats sont illustratifs et ne constituent pas un conseil financier.",
    
    // Parcours Onboarding
    parcoursTitle: "Bien joué 👏 Ton parcours commence ici",
    parcoursSubtitle: "Tu as clarifié ton profil. Maintenant, on avance pas à pas, sans pression.\nTu peux t'arrêter et reprendre quand tu veux.",
    parcoursProfileLabel: "Profil",
    parcoursAllocationLabel: "Répartition",
    parcoursTimelineWeb3: "Web3 — gratification immédiate",
    parcoursTimelineAI: "Trading IA — rythme & structure",
    parcoursTimelineDCA: "DCA — long terme & stabilité",
    parcoursCTAStart: "Lancer le parcours 🚀",
    parcoursCTAStartSubtext: "Étape 1 : Web3 (gratification immédiate)",
    parcoursCTABack: "Revoir mon Sim360",
    parcoursResume: "Reprendre où j'en étais",
    parcoursNoSnapshot: "Commence par compléter le Simulateur 360° pour définir ton profil",
    goToParcours: "Continuer vers le Parcours",
    goToParcoursDesc: "Prêt à passer à l'action ? Suis un chemin guidé pas à pas.",
    parcoursMapTitle: "Ta carte de voyage",
    parcoursStartAlert: "Navigation vers l'Étape 1 (Web3) sera bientôt disponible",
    
    // Jairvis Maintenance
    enMaintenance: "en maintenance",
    jairvisMaintenanceShort: "Temporairement suspendu",
    jairvisMaintenanceTitle: "❗ Point clé identifié : des trades trop longtemps ouverts",
    jairvisMaintenanceText1: "Nous avons constaté que certains trades sur JAIRVIS restent ouverts sur des périodes trop longues.",
    jairvisMaintenanceText2: "Dans les standards de qualité du club, il est important que les IA ferment les trades plusieurs weekends par mois afin que les membres puissent disposer de leurs dépôts si besoin de retraits ou autres.",
    jairvisMaintenanceText3: "Des trades trop longs retardent donc :",
    jairvisMaintenancePoint1: "la disponibilité des fonds pour les membres",
    jairvisMaintenanceText4: "Par conséquent, nous avons temporairement suspendu l'accès au copy trading de JAIRVIS, le temps que son créateur puisse retravailler l'IA afin de répondre aux standards recherchés, avec pour objectif d'avoir 100% des trades clôturés 2 à 3 fois par semaine.",
    
    // AI Trading Pole Vision
    aiPoleVisionTitle: "🎯 Vision du Pôle Trading IA",
    aiPoleVisionText1: "La vision du Pôle Trading IA est de constamment monitorer les résultats des IA et d'avoir une communication directe avec leurs créateurs pour maintenir le niveau de standard recherché.",
    aiPoleVisionText2: "Ce n'est pas une mauvaise chose qu'une IA retourne au 'garage' si elle ne respecte plus les standards. En parallèle, dans le club nous analysons et suivons constamment différentes IA de trading pour ensuite les proposer dans le Club.",
    aiPoleVisionText3: "C'est une vision adaptative et évolutive. La qualité pour nos membres est le plus important.",
    aiPoleVisionText4: "Un des facteurs pour qu'une IA soit approuvée : elle doit avoir au moins 500 trades réalisés sur un même compte.",

    // Navigation
    backofficeExternal: "Backoffice",
    myPortafolio: "Mon Portafolio",

    // My Portafolio promo block (home)
    portafolioPromoTitle: "Suivez tout dans Mon Portafolio",
    portafolioPromoLead: "Votre tableau de bord unifié — connectez votre MT4/5 (Sigmai, Sugair, Jairvis), votre wallet BEP20, vos plans KAP3 et votre DCA manuel, tout dans une seule vue néon.",
    portafolioPromoFeature1: "Métriques MT4/5 en temps réel via MetaApi",
    portafolioPromoFeature2: "Wallet BEP20 + plans KAP3 on-chain",
    portafolioPromoFeature3: "Tracker DCA Bitcoin manuel + Performance Card",
    portafolioPromoSignup: "Créer mon compte",
    portafolioPromoLogin: "J'ai déjà un compte",

    // Auth (email/password)
    authLoginTitle: "Bon retour",
    authRegisterTitle: "Créer votre compte",
    authEmail: "Email",
    authPassword: "Mot de passe",
    authName: "Nom (optionnel)",
    authSubmitLogin: "Se connecter",
    authSubmitRegister: "Créer le compte",
    authToRegister: "Pas encore de compte ? Inscrivez-vous",
    authToLogin: "Déjà un compte ? Connectez-vous",
    authForgot: "Mot de passe oublié ?",
    authForgotHelp: "Nous n'envoyons pas d'emails. Ouvre un ticket de support et on te le réinitialise.",
    authOr: "ou",
    authGoogle: "Continuer avec Google",
    authError: "Échec de la connexion",
    authPasswordHint: "Minimum 6 caractères",
  },

  es: {
    appTitle: "Simulador 360°",
    appName: "Simulador 360°",
    metaTitle: "Simulador 360° — Herramienta educativa de portafolio",
    metaDesc: "Modela y entiende tu portafolio con DCA, Crypto, Trading con IA y Web3. Resultados ilustrativos. No es consejo financiero.",
    ogImage: "/assets/branding/og-es.png",
    appSubtitle: "Herramienta educativa para aprender a modelar un portafolio digital.",
    config: "Configuración del portafolio",
    capital: "Capital digital inicial (USD)",
    monthlyContributionLabel: "Aporte mensual (USD)",
    monthlyContributionHelp: "Monto agregado cada mes y distribuido según tus porcentajes actuales de asignación.",
    profile: "Perfil de miembro",
    conservative: "Conservador",
    balanced: "Equilibrado",
    exotic: "Exótico",
    customProfile: "(Personalizado)",
    customProfileMessage: "Las asignaciones han sido modificadas manualmente",
    autoNormalize: "Auto-normalizar",
    custom: "Personalizado",
    customHint: "(Perfil personalizado)",
    resetPreset: "Restablecer al perfil",
    saveAsDefault: "Guardar como nuevo por defecto",
    login: "Login",
    logout: "Logout",
    changeLanguage: "Cambiar idioma",
    guide: "Guía",
    backoffice: "Backoffice",

    baskets: "Canastas",
    dcaCrypto: "DCA Bitcoin & Crypto",
    btcDca: "DCA Bitcoin & Crypto",
    crypto: "DCA Bitcoin & Crypto",
    aiTrading: "Trading con IA",
    web3: "Web3 Staking & Farming",

    aiSplit: "Distribución Trading con IA",
    sigmai: "Sigmai",
    sugair: "Sugair",
    jairvis: "Jairvis",
    jarvis: "Jairvis",

    assumptions: "Supuestos de rendimiento (editables)",
    annual: "Anual",
    monthly: "Mensual",
    rateDcaCrypto: "DCA Bitcoin & Crypto: 40% anual",
    rateBtc: "DCA Bitcoin & Crypto: 40% anual",
    rateCrypto: "DCA Bitcoin & Crypto: 40% anual",
    rateJairvis: "Jairvis: 3.48% mensual",
    rateJarvis: "Jairvis: 3.48% mensual",
    rateSugair: "Sugair: 4.50% mensual",
    rateSigmai: "Sigmai: 3.48% mensual",
    rateWeb3: "Web3: 3.50% mensual",

    projections: "Proyecciones",
    horizon90d: "90 días",
    horizon1y: "1 año",
    horizon3y: "3 años",
    horizon5y: "5 años",

    results: "Resultados",
    basket: "Canasta",
    allocationUsd: "Asignación (USD)",
    rate: "Tasa",
    fv90d: "VF 90d",
    fv1y: "VF 1 año",
    fv5y: "VF 5 años",
    delta: "Δ vs inicial",
    total: "TOTAL",

    actions: "Acciones",
    copyLink: "Copiar link",
    exportPdf: "Exportar PDF",

    tooltipBtc: "Acumulación progresiva vía DCA en Bitcoin y Crypto.",
    tooltipCrypto: "Acumulación progresiva vía DCA en Bitcoin y Crypto.",
    tooltipDcaCrypto: "Acumulación progresiva vía DCA en Bitcoin y Crypto.",
    tooltipAI: "Bots IA: Sigmai, Sugair, Jairvis (distribución interna).",
    tooltipWeb3: "Rendimientos vía staking/farming (KAP3, etc.).",

    disclaimer:
      "Herramienta educativa: El DCA Club no es una empresa de inversión ni de recomendación. Todo lo que se hace en el Club tiene un único objetivo educativo y en un marco técnico, para que cada miembro pueda estar más preparado al momento de navegar por sí mismo en el mundo digital. Esta herramienta busca enseñar cómo se crea y ajusta un portafolio, y el portafolio también podría construirse con otras herramientas digitales distintas a las aquí propuestas, siempre con fines educativos. Todos los resultados presentados son ilustrativos y pueden no reflejar la realidad. No es consejo financiero. Los resultados pasados no garantizan rendimientos futuros. Cada miembro siempre será el único responsable de sus decisiones.",
    eduBadge: "Herramienta educativa",

    langSwitch: "FR",
    
    // Additional translations
    portfolioAllocation: "Asignación del portafolio",
    portfolioGrowthProjection: "Proyección de crecimiento del portafolio",
    detailedProjections: "Proyecciones detalladas",
    totalCapital: "Capital total",
    finalValue: "Valor final",
    totalGain: "Ganancia total",
    returnPercent: "Retorno %",
    aiTradingBreakdown: "Desglose Trading con IA",
    aiAllocationBreakdown: "Desglose de asignación IA",
    allocationsMustSum: "Las asignaciones deben sumar 100%. Total actual:",
    aiSplitMustSum: "La distribución IA debe sumar 100%. Actual:",
    monthlyReturns: "rendimientos mensuales",
    ofAI: "de IA",
    totalPortfolio: "PORTAFOLIO TOTAL",
    contributionsTotal: "Aportes acumulados",
    netGain: "Ganancia neta",
    roi: "ROI",
    basketContrib: "Aporte acumulado",
    
    // E) New text keys for UI improvements
    seeMore: "Ver más",
    seeLess: "Ver menos", 
    contributions: "Aportes acumulados",
    compounding: "Crecimiento compuesto",
    
    // D) AI Trading Performance Fee tooltips
    aiPerformanceFeeTooltip: "Rendimiento neto después de 30% comisión semanal sobre ganancias",
    grossRate: "Tasa bruta",
    netRate: "Tasa neta",
    
    // Jairvis specific tooltips
    aiJairvis: "Jairvis",
    tooltipJairvis: "Rendimientos gestionados por Jairvis.",
    
    // Social image alt text
    socialImageAlt: "DCA Visión 360° - Herramienta educativa para modelar portafolios digitales",
    
    // B) Data Export
    exportCsv: "Exportar CSV",
    exportExcel: "Exportar Excel",
    exportPdf: "Exportar PDF",
    exportSuccess: "¡Exportación exitosa!",
    exportError: "Error en la exportación",
    
    // Export Confirmation Modal
    exportWarningTitle: "Aviso de Contenido Educativo",
    exportWarningMessage: "Este documento contiene proyecciones educativas únicamente. NO es consejo financiero. Los resultados pasados no garantizan rendimientos futuros. Usted es el único responsable de sus decisiones de inversión.",
    exportWarningConfirm: "Entiendo, descargar documento",
    exportWarningCancel: "Cancelar",
    exportContact: "Para más información, contacte a: team@thedcaclub.com",
    
    // Section descriptions
    configDescription: "Ajusta tu capital inicial y aportes mensuales para ver cómo podría crecer tu portafolio en el tiempo.",
    portfolioAllocationDescription: "Arrastra los sliders para distribuir tu inversión entre las 3 canastas DCA Bitcoin & Crypto, Trading con IA y Web3. El total debe sumar 100%.",
    assumptionsDescription: "Estas tasas son estimaciones educativas basadas en datos históricos. Los resultados pasados no garantizan resultados futuros. Puedes ajustarlas según tus propias proyecciones.",
    assumptionsWarning: "Importante: Actúa con responsabilidad y sigue un plan DCA bien definido. Estas son proyecciones, no promesas.",
    aiTradingAnnualLabel: "Trading con IA — Tasa anual promedio",
    aiTradingAnnualHelp: "Rendimiento anual agregado de la canasta Trading con IA (promedio ponderado de Sigmai, Sugair y Jairvis). Al editarlo se aplica una tasa mensual equivalente a los tres bots.",
    // Capital Flow
    capitalFlowTitle: "Flujo de Capital — A dónde va tu dinero",
    capitalFlowSubtitle: "Visualización de cómo se distribuye tu capital entre canastas, bots de IA y su proyección en el tiempo.",
    flowColCapital: "CAPITAL",
    flowColBaskets: "CANASTAS",
    flowColAiSplit: "REPARTO IA",
    flowColFinalValue: "VALOR FINAL",
    flowInitial: "Capital inicial",
    flowHoverHint: "Pasa el mouse sobre un flujo para ver el detalle",
    // Portfolio Card
    portfolioCardTitle: "Tu Tarjeta de Portafolio",
    portfolioCardSubtitle: "Una instantánea coleccionable de tu simulación — lista para descargar y compartir.",
    portfolioCardDescription: "Descárgala como imagen de alta calidad o compártela en WhatsApp junto a una invitación para que tus amigos creen la suya. La rareza depende de tu perfil de miembro.",
    portfolioCardProfile: "Perfil",
    portfolioCard5yProjection: "Proyección a 5 años",
    portfolioCardEducational: "Simulador 360°",
    portfolioCardDownloadPng: "Descargar PNG",
    portfolioCardDownloading: "Generando...",
    cardDownloadError: "No se pudo generar la imagen. Intenta de nuevo.",
    portfolioCardPreparing: "Preparando imagen...",
    portfolioCardAttachNotice: "Tu tarjeta se descargó. Adjunta la imagen descargada en WhatsApp Web para enviarla junto al mensaje.",
    // Scenario Multiverse
    multiverseTitle: "Multiverso de Escenarios — Explora futuros paralelos",
    multiverseSubtitle: "Compara cómo tu portafolio podría evolucionar bajo 3 escenarios alternativos de rendimiento.",
    scenarioPessimistic: "Pesimista",
    scenarioRealistic: "Realista",
    scenarioOptimistic: "Optimista",
    scenarioCurrent: "actual",
    multiverseFV5y: "Valor Final · 5 años",
    multiverseNetGain: "Ganancia neta",
    multiverseDisclaimer: "Ilustración educativa únicamente — los rendimientos no están garantizados.",
    projectionDescription: "Visualiza cómo tu portafolio podría crecer con interés compuesto en diferentes períodos de tiempo.",
    
    // Help section
    howItWorksTitle: "¿Cómo funciona el simulador?",
    howItWorksStep1: "1. Define tu capital",
    howItWorksStep1Desc: "Ingresa el monto de tu inversión inicial y tu aporte mensual.",
    howItWorksStep2: "2. Asigna tu portafolio",
    howItWorksStep2Desc: "Usa los sliders para distribuir tu capital entre las 3 canastas DCA Bitcoin & Crypto, Trading con IA y Web3.",
    howItWorksStep3: "3. Ajusta los supuestos de rendimiento",
    howItWorksStep3Desc: "Modifica las tasas de retorno esperadas si tienes tus propias proyecciones.",
    howItWorksStep4: "4. Analiza las proyecciones",
    howItWorksStep4Desc: "Revisa los gráficos de crecimiento y tablas detalladas para entender los resultados potenciales.",
    howItWorksDisclaimer: "Recuerda: Esta es una herramienta educativa. Los resultados son ilustrativos y no constituyen asesoría financiera.",
    
    // Parcours Onboarding
    parcoursTitle: "Bien hecho 👏 Tu parcours empieza aquí",
    parcoursSubtitle: "Ya aclaraste tu perfil. Ahora, avanzamos paso a paso, sin presión.\nPuedes parar y retomar cuando quieras.",
    parcoursProfileLabel: "Perfil",
    parcoursAllocationLabel: "Distribución",
    parcoursTimelineWeb3: "Web3 — gratificación inmediata",
    parcoursTimelineAI: "Trading IA — ritmo y estructura",
    parcoursTimelineDCA: "DCA — largo plazo y estabilidad",
    parcoursCTAStart: "Lanzar el parcours 🚀",
    parcoursCTAStartSubtext: "Paso 1: Web3 (gratificación inmediata)",
    parcoursCTABack: "Volver a mi Sim360",
    parcoursResume: "Retomar donde lo dejé",
    parcoursNoSnapshot: "Empieza completando el Simulador 360° para definir tu perfil",
    goToParcours: "Continuar al Parcours",
    goToParcoursDesc: "¿Listo para pasar a la acción? Sigue una ruta guiada paso a paso.",
    parcoursMapTitle: "Tu mapa de viaje",
    parcoursStartAlert: "Navegación al Paso 1 (Web3) se implementará próximamente",
    
    // Jairvis Maintenance
    enMaintenance: "en mantenimiento",
    jairvisMaintenanceShort: "Temporalmente suspendido",
    jairvisMaintenanceTitle: "❗ Punto clave identificado: trades abiertos demasiado tiempo",
    jairvisMaintenanceText1: "Hemos constatado que algunos trades en JAIRVIS permanecen abiertos durante períodos demasiado largos.",
    jairvisMaintenanceText2: "En los estándares de calidad del club, es importante que las IA cierren los trades varios fines de semana al mes para que los miembros puedan disponer de sus depósitos si necesitan retiros u otras necesidades.",
    jairvisMaintenanceText3: "Los trades demasiado largos retrasan:",
    jairvisMaintenancePoint1: "la disponibilidad de fondos para los miembros",
    jairvisMaintenanceText4: "Por consiguiente, hemos suspendido temporalmente el acceso al copy trading de JAIRVIS, mientras su creador retrabaja la IA para cumplir con los estándares requeridos, con el objetivo de tener el 100% de los trades cerrados 2 a 3 veces por semana.",
    
    // AI Trading Pole Vision
    aiPoleVisionTitle: "🎯 Visión del Polo Trading IA",
    aiPoleVisionText1: "La visión del Polo Trading IA es monitorear constantemente los resultados de las IA y mantener comunicación directa con sus creadores para mantener el nivel de estándar buscado.",
    aiPoleVisionText2: "No es algo malo que una IA regrese al 'garage' si ya no respeta los estándares. En paralelo, en el club estamos constantemente analizando y siguiendo diferentes IA de trading para luego ofrecerlas en el Club.",
    aiPoleVisionText3: "Es una visión adaptativa y evolutiva. La calidad para nuestros miembros es lo más importante.",
    aiPoleVisionText4: "Uno de los factores para que una IA sea aprobada: debe tener al menos 500 trades realizados en una misma cuenta.",

    // Navigation
    backofficeExternal: "Backoffice",
    myPortafolio: "Mi Portafolio",

    // My Portafolio promo block (home)
    portafolioPromoTitle: "Sigue todo en Mi Portafolio",
    portafolioPromoLead: "Tu dashboard unificado de miembro — conecta tu MT4/5 (Sigmai, Sugair, Jairvis), tu wallet BEP20, tus planes KAP3 y tu DCA manual, todo en una sola vista neón.",
    portafolioPromoFeature1: "Métricas MT4/5 en tiempo real vía MetaApi",
    portafolioPromoFeature2: "Wallet BEP20 + planes KAP3 on-chain",
    portafolioPromoFeature3: "Tracker DCA Bitcoin manual + Performance Card",
    portafolioPromoSignup: "Crear mi cuenta",
    portafolioPromoLogin: "Ya tengo una cuenta",

    // Auth (email/password)
    authLoginTitle: "Bienvenido de nuevo",
    authRegisterTitle: "Crea tu cuenta",
    authEmail: "Correo",
    authPassword: "Contraseña",
    authName: "Nombre (opcional)",
    authSubmitLogin: "Iniciar sesión",
    authSubmitRegister: "Crear cuenta",
    authToRegister: "¿Sin cuenta? Regístrate",
    authToLogin: "¿Ya tienes cuenta? Inicia sesión",
    authForgot: "¿Olvidaste tu contraseña?",
    authForgotHelp: "No enviamos correos. Abre un ticket de soporte y te la reseteamos.",
    authOr: "o",
    authGoogle: "Continuar con Google",
    authError: "Error al iniciar sesión",
    authPasswordHint: "Mínimo 6 caracteres",
  },
};